<template>
  <div class="glass-card rounded-2xl p-4 md:p-6">
    <!-- Header -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-5">
      <div class="flex items-center gap-3">
        <div class="relative">
          <div class="h-10 w-10 rounded-xl border border-white/10 bg-white/5 flex items-center justify-center">
            <svg class="w-5 h-5 text-indigo-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5l2 2h5a2 2 0 012 2v12a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <span class="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-emerald-400 animate-pulse"></span>
        </div>

        <div>
          <h3 class="text-lg md:text-xl font-extrabold">
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-300 via-fuchsia-300 to-amber-300">
              سفارشات اخیر
            </span>
          </h3>
        </div>
      </div>

      <div class="flex-shrink-0 items-center gap-2 self-start md:self-auto">
        <button
            @click="fetchOrders"
            class="inline-flex  ml-2 items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold
                 border border-white/10 bg-white/5 text-slate-200
                 hover:bg-white/10 transition"
            title="رفرش"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          رفرش
        </button>

        <button
            @click="printOrders"
            class="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold text-white
                 bg-gradient-to-r from-indigo-600/90 via-purple-600/90 to-fuchsia-600/90
                 border border-white/10 shadow-lg shadow-black/30
                 hover:opacity-95 hover:scale-[1.01] active:scale-[0.99] transition"
            title="پرینت"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
          </svg>
          پرینت
        </button>
      </div>
    </div>

    <!-- Filters -->
    <div class="rounded-2xl border border-white/10 bg-white/5 p-3 md:p-4 mb-5">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
        <!-- status -->
        <div class="md:col-span-2">
          <label class="block text-[11px] text-slate-400 mb-1">وضعیت</label>
          <select v-model="filters.status" @change="fetchOrders" class="filter-input">
            <option value="">همه وضعیت‌ها</option>
            <option v-for="(label, key) in statusLabels" :key="key" :value="key">{{ label }}</option>
          </select>
        </div>

        <!-- id -->
        <div class="md:col-span-2">
          <label class="block text-[11px] text-slate-400 mb-1">شماره سفارش</label>
          <input v-model="filters.id" @input="fetchOrders" type="number" placeholder="مثلاً 1234" class="filter-input" />
        </div>

        <!-- search -->
        <div class="md:col-span-3">
          <label class="block text-[11px] text-slate-400 mb-1">جستجو</label>
          <input v-model="filters.search" @input="fetchOrders" type="text" placeholder="موبایل / کد رهگیری / ..." class="filter-input" />
        </div>

        <!-- quick date -->
        <div class="md:col-span-2">
          <label class="block text-[11px] text-slate-400 mb-1">فیلتر سریع تاریخ</label>
          <select v-model="filters.quick_date_filter" @change="applyQuickDateFilter" class="filter-input">
            <option value="">انتخاب</option>
            <option v-for="(label, key) in quickDateLAbles" :key="key" :value="key">{{ label }}</option>
          </select>
        </div>

        <div class="md:col-span-1">
          <button

              @click="clearFilters"
              class=" px-3 py-2 rounded-lg text-center text-xs font-semibold
                   border border-white/10 bg-red-300/10 text-slate-200
                   hover:bg-white/10 transition"
          >
            پاک کردن
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="rounded-2xl border border-white/10 bg-slate-950/30 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full table-auto text-right">
          <thead class="sticky top-0 z-10">
          <tr class="text-[11px] text-slate-300 bg-slate-950/70 backdrop-blur-2xl">
            <th class="th">شماره</th>
            <th class="th">تاریخ</th>
            <th class="th">کد رهگیری</th>
            <th class="th">وضعیت</th>
            <th class="th">اقلام</th>
            <th class="th">مبلغ</th>
            <th class="th">ارسال</th>
            <th class="th">تخفیف</th>
            <th class="th">کل</th>
            <th class="th">مشتری</th>
            <th class="th">پرداخت</th>
          </tr>
          </thead>

          <tbody class="text-slate-200 text-sm">
          <tr
              v-for="order in orders"
              :key="order.id"
              @click="$router.push(`/panel/adminOrderDetail/${order.id}`)"
              class="cursor-pointer border-t border-white/10 hover:bg-white/5 transition"
          >
            <td class="td text-center font-semibold text-indigo-200">{{ order.id }}</td>
            <td class="td text-[12px] text-slate-300">{{ formatDate(order.date_time) }}</td>
            <td class="td text-[12px]">{{ order.exuni_tracking_code || "-" }}</td>

            <td class="td">
                <span :class="statusClass(order.status)">
                  {{ statusLabels[order.status] || order.status }}
                </span>
            </td>

            <td class="td">
              {{ order.total_product_quantity | toMoney }}
              <span class="unit">عدد</span>
            </td>

            <td class="td">
              {{ order.total_price | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td">
              {{ order.post_price | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td">
              {{ order.total_discount | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td font-bold text-emerald-200">
              {{ order.final_amount | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td">
              <div class="flex flex-col gap-0.5">
                <span class="text-[12px] text-slate-100">{{ order.customer.mobile_number || "-" }}</span>
                <span class="text-[11px] text-slate-400">
                    {{ order.shipment_address.first_name || "" }}
                    {{ order.shipment_address.last_name || "" }}
                  </span>
              </div>
            </td>

            <td class="td text-[12px] text-slate-300">{{ order.payment_display || "-" }}</td>
          </tr>

          <!-- Totals -->
          <tr class="border-t border-white/10 bg-white/5">
            <td class="td text-center font-extrabold text-slate-100" colspan="4">جمع کل</td>

            <td class="td font-bold">
              {{ totals.total_product_quantity }}
              <span class="unit">عدد</span>
            </td>

            <td class="td font-bold">
              {{ totals.total_price | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td font-bold">
              {{ totals.post_price | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td font-bold">
              {{ totals.total_discount | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td font-extrabold text-emerald-200">
              {{ totals.final_amount | toMoney }}
              <span class="unit">تومان</span>
            </td>

            <td class="td" colspan="2"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopOrdersListTable",
  data() {
    return {
      orders: [],
      selected: [],
      selectAll: false,
      pagination: {
        current_page: 1,
        page_size: 20,
        total_items: 0,
      },
      filters: {
        id: "",
        status: "",
        search: "",
        date_from: "",
        date_to: "",
        quick_date_filter: "",
      },
      statusLabels: {
        pa: "جاری",
        sh: "ارسال شده",
        ex: "منقضی شده",
      },
      quickDateLAbles: {
        today: "امروز",
        yesterday: "دیروز",
        this_month: "این ماه",
      },
    };
  },
  computed: {
    filteredOrders() {
      return this.orders;
    },
    totals() {
      return this.filteredOrders.reduce(
          (sum, order) => {
            sum.total_product_quantity += Number(order.total_product_quantity || 0);
            sum.total_price += Number(order.total_price || 0);
            sum.post_price += Number(order.post_price || 0);
            sum.total_discount += Number(order.total_discount || 0);
            sum.final_amount += Number(order.final_amount || 0);
            return sum;
          },
          {
            total_product_quantity: 0,
            total_price: 0,
            post_price: 0,
            total_discount: 0,
            final_amount: 0,
          }
      );
    },
  },
  methods: {
    fetchOrders() {
      let fetch_url = `shop/shopOrderList/all?`;

      if (this.filters.status) fetch_url += `status=${this.filters.status}&`;
      if (this.filters.id) fetch_url += `id=${this.filters.id}&`;
      if (this.filters.search) fetch_url += `search_value=${this.filters.search}&`;
      if (this.filters.quick_date_filter) fetch_url += `quick_date_filter=${this.filters.quick_date_filter}&`;
      if (this.filters.date_from) fetch_url += `date_from=${this.filters.date_from}&`;
      if (this.filters.date_to) fetch_url += `date_to=${this.filters.date_to}&`;

      fetch_url += `limit=${this.pagination.page_size}&offset=${(this.pagination.current_page - 1) * this.pagination.page_size}&`;

      this.request({
        url: this.endpoint(fetch_url),
        loading: true,
        method: "get",
        success: (data) => {
          this.orders = data.results || [];
        },
      });
    },
    printOrders() {
      let print_url = `https://api.exuni.ir/shop/adminOrdersList/html?token=${this.token}&`;

      if (this.selected.length > 0) print_url += `id__in=${this.selected.join(",")}&`;
      if (this.filters.status) print_url += `status=${this.filters.status}&`;
      if (this.filters.id) print_url += `id=${this.filters.id}&`;
      if (this.filters.search) print_url += `search_value=${this.filters.search}&`;
      if (this.filters.quick_date_filter) print_url += `quick_date_filter=${this.filters.quick_date_filter}&`;
      if (this.filters.date_from) print_url += `date_from=${this.filters.date_from}&`;
      if (this.filters.date_to) print_url += `date_to=${this.filters.date_to}&`;

      print_url += `limit=${this.pagination.page_size}&offset=${(this.pagination.current_page - 1) * this.pagination.page_size}&`;

      window.open(print_url);
    },
    toggleSelectAll() {
      this.selected = this.selectAll ? this.filteredOrders.map((o) => o.id) : [];
    },
    statusClass(status) {
      // neon badges
      const map = {
        pe: "badge badge-warn",
        pa: "badge badge-ok",
        pr: "badge badge-info",
        pc: "badge badge-violet",
        sh: "badge badge-pink",
        de: "badge badge-ok",
        ca: "badge badge-danger",
        re: "badge badge-muted",
        ex: "badge badge-muted",
      };
      return map[status] || "badge badge-muted";
    },
    formatDate(date) {
      return date ? date.split("T")[0] : "-";
    },
    applyQuickDateFilter() {
      this.filters.date_from = "";
      this.filters.date_to = "";
      this.fetchOrders();
    },
    clearFilters() {
      this.filters = {
        id: "",
        status: "",
        search: "",
        date_from: "",
        date_to: "",
        quick_date_filter: "",
      };
      this.fetchOrders();
    },
  },
  mounted() {
    this.fetchOrders();
  },
};
</script>

<style scoped>
/* inputs */
.filter-input{
  width: 100%;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.10);
  color: rgba(226,232,240,1);
  font-size: 12px;
  outline: none;
  transition: 150ms;
}
.filter-input:focus{
  border-color: rgba(99,102,241,0.55);
  box-shadow: 0 0 0 3px rgba(99,102,241,0.20);
}
.filter-input::placeholder{ color: rgba(148,163,184,0.8); }

/* table cells */
.th{
  padding: 12px 10px;
  border-bottom: 1px solid rgba(255,255,255,0.10);
  white-space: nowrap;
}
.td{
  padding: 12px 10px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  white-space: nowrap;
}
.unit{
  font-size: 10px;
  color: rgba(148,163,184,0.9);
  margin-right: 6px;
}

/* badges */
.badge{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.06);
}
.badge-ok{ color: rgba(110,231,183,1); background: rgba(16,185,129,0.10); border-color: rgba(16,185,129,0.25); }
.badge-info{ color: rgba(147,197,253,1); background: rgba(59,130,246,0.10); border-color: rgba(59,130,246,0.25); }
.badge-warn{ color: rgba(253,224,71,1); background: rgba(234,179,8,0.10); border-color: rgba(234,179,8,0.25); }
.badge-violet{ color: rgba(196,181,253,1); background: rgba(139,92,246,0.10); border-color: rgba(139,92,246,0.25); }
.badge-pink{ color: rgba(251,113,133,1); background: rgba(236,72,153,0.10); border-color: rgba(236,72,153,0.25); }
.badge-danger{ color: rgba(252,165,165,1); background: rgba(239,68,68,0.10); border-color: rgba(239,68,68,0.25); }
.badge-muted{ color: rgba(148,163,184,1); background: rgba(148,163,184,0.08); border-color: rgba(255,255,255,0.10); }
</style>
